export default "__VITE_ASSET__Dc6sqrZY__"